export default __webpack_public_path__ + "static/media/healing_vegetable_soup.7edc1c21.jpg";